/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedFamilyRequest
 */
export interface APIPatchedFamilyRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedFamilyRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the APIPatchedFamilyRequest interface.
 */
export function instanceOfAPIPatchedFamilyRequest(value: object): value is APIPatchedFamilyRequest {
    return true;
}

export function APIPatchedFamilyRequestFromJSON(json: any): APIPatchedFamilyRequest {
    return APIPatchedFamilyRequestFromJSONTyped(json, false);
}

export function APIPatchedFamilyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedFamilyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function APIPatchedFamilyRequestToJSON(value?: APIPatchedFamilyRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

